import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { EscolhaModalidadeGuard } from "src/app/interceptors/escolha-modalidade.guard";
import { DominiosResolver } from "src/app/shared/resolvers/dominios.resolver";
import { ProgramasPermitidosPorCestasPesquisaComponent } from "./pesquisa/programas-permitidos-por-cestas-pesquisa.component";
import { HabilitacaoProgramaComponent } from "./habilitacao-programa/habilitacao-programa.component";
import { ProgramasPermitidosPorCestasEdicaoComponent } from "./edicao/programas-permitidos-por-cestas-edicao.component";


const routes: Routes = [
  {
    path: 'programas-permitidos-por-cestas',
    component: ProgramasPermitidosPorCestasPesquisaComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {dominios: DominiosResolver},
    data: { canReuse: false },
  },
  {
    path: 'programas-permitidos-por-cestas/habilitacao-programa/:idTranche',
    component: HabilitacaoProgramaComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {dominios: DominiosResolver},
    data: { canReuse: false },
  },
  {
    path: 'programas-permitidos-por-cestas/edicao-programa/:idePrograma',
    component: ProgramasPermitidosPorCestasEdicaoComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {dominios: DominiosResolver},
    data: { canReuse: false },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class ProgramasPermitidosPorCestasRoutingModule { }
